module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.e971abae.eot";